<mat-form-field [class.full-width]="!inline">
  <input matInput type="text" #cliente [placeholder]="label" (onfocus)="handleFocus()" [value]="(filtroCliente | async)" (keyup)="handleFiltro($event.target.value)" [matAutocomplete]="auto">
</mat-form-field>
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFundo" (optionSelected)="selectFundo($event.option.value)">
  <mat-option *ngFor="let option of (clientes$ | async)" [value]="option">{{option.nome}} - {{option.cnpj | mask:'00.000.000/0000-00'}}</mat-option>
</mat-autocomplete>